import React, { useState, useEffect } from 'react';
import slide1 from '../../assets/images/slide1.png';
import slide2 from '../../assets/images/slide2.png';
import slide3 from '../../assets/images/slide3.png';
import slide4 from '../../assets/images/slide4.png';
import slide5 from '../../assets/images/slide5.png';
import './AuthIntroSection.css';

/**
 * AuthIntroSection Component
 * 
 * Left content section with auto-rotating carousel displaying branding, 
 * heading, description, and illustrations for authentication pages
 * 
 * Features:
 * - 4 slides with auto-rotation
 * - Smooth transitions
 * - Interactive dot indicators
 * - Continuous loop
 * 
 * @component
 */

// Carousel slides data
const SLIDES = [
  {
    id: 1,
    heading: (
      <>
        <span style={{ color: '#FCBA05' }}>real-time</span>, retail digital marketplace
      </>
    ),
    description:
      "meet every customer where you are with beemz location based digital services. from menu's to catalogs, take customer orders and inquiries, process in-app payments and even market your business on beemz.",
    image: slide2,
    alt: 'retail marketplace illustration',
  },
  {
    id: 2,
    heading: (
      <>
        <span style={{ color: '#FCBA05' }}>more affordable</span> than the rest, smarter for you!
      </>
    ),
    description:
      'beemz combines continuous ordering, customer and inventory management, along with innovative ai support, improving customer loyalty and your bottom line. low fixed fee, no commission promise – your revenue is yours!',
    image: slide3,
    alt: 'affordable solution illustration',
  },
  {
    id: 3,
    heading: (
      <>
        <span style={{ color: '#FCBA05' }}>multi-platform,</span> on mobile and web, download now!
      </>
    ),
    description:
      'with beɘmz digital services – menus, catalogs, customer orders and inquiries, in-app transactions and advertising, you will save up to 300% compared to others',
    image: slide4,
    alt: 'affordable solution illustration',
  },
  {
    id: 4,
    heading: (
      <>
        <span style={{ color: '#FCBA05' }}>serve more, spend less</span> with chat ordering
      </>
    ),
    description:
      'every order costs time and money. traditional waiters can only take one table at a time - writing, walking, re-entering, and relaying orders to the kitchen. beɘmz replaces that with instant, unlimited chat-based ordering and kitchen relay - at a fraction of the cost.',
    image: slide5,
    alt: 'ride share illustration',
  },
  {
    id: 5,
    heading: (
      <>
        your <span style={{ color: '#FCBA05' }}>digital growth</span> command center
      </>
    ),
    description:
      "from seamless operations to smarter customer engagement, every feature is built to boost efficiency, delight customers, and maximize revenue. zero commission model, your revenue is yours keep your profit in your pocket.",
    image: slide1,
    alt: 'digital growth illustration',
  },
];


const AuthIntroSection = () => {
  // Current active slide index
  const [currentSlide, setCurrentSlide] = useState(0);
  
  // Auto-rotate carousel every 8-10 seconds (tripled from original)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % SLIDES.length);
    }, 9000); // 9 seconds per slide (3x the original 3 seconds)

    return () => clearInterval(interval);
  }, []);

  // Handle dot click
  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  // Get current slide data
  const currentSlideData = SLIDES[currentSlide];

  return (
    <div className="auth-intro">
      {/* Content wrapper */}
      <div className="auth-intro__content">
        {/* Carousel slide content with fade transition */}
        <div className="auth-intro__slide" key={currentSlideData.id}>
          {/* Heading */}
          <h1 className="auth-intro__heading">
            {currentSlideData.heading}
          </h1>

          {/* Description */}
          <p className="auth-intro__description">
            {currentSlideData.description}
          </p>

          {/* Illustration */}
          <div className="auth-intro__illustration">
            <img 
              src={currentSlideData.image} 
              alt={currentSlideData.alt}
              className="auth-intro__image"
            />
          </div>
        </div>

        {/* Slider dots indicator (interactive) */}
        <div className="auth-intro__slider-dots">
          {SLIDES.map((slide, index) => (
            <button
              key={slide.id}
              className={`auth-intro__dot ${index === currentSlide ? 'auth-intro__dot--active' : ''}`}
              onClick={() => handleDotClick(index)}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default AuthIntroSection;
